module.exports = ".userbox {\r\n    min-height: 100% !important;\r\n}\r\n\r\n.table-grid-design tr, td {\r\n    padding: 3px;\r\n    text-align: left;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/my-house/my-house-details/myhouse-grid/myhouse-grid.component.css
// module id = ./src/app/modules/dashboard/my-house/my-house-details/myhouse-grid/myhouse-grid.component.css
// module chunks = dashboard.module